var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMibw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.02 130.381L110.964 125.344L108.864 127.435L113.92 132.473L116.02 130.381Z",
    fill: "#084A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.056 131.901L120.088 131.982L120.283 139.102L123.252 139.02L123.056 131.901Z",
    fill: "#E5364E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.504 149.753L128.023 143.552L125.438 142.096L121.919 148.296L124.504 149.753Z",
    fill: "#CD9E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.442 156.342L118.578 159.075L125.185 156.352L124.048 153.617L117.442 156.342Z",
    fill: "#1FA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 163.33L115.826 164.648L116.377 161.741L109.351 160.422L108.8 163.33Z",
    fill: "#C9224C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0323 160.745L102.749 166.095L104.981 164.143L100.263 158.793L98.0323 160.745Z",
    fill: "#EA584B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7073 152.876L90.7505 153.154L91.4182 160.245L94.3751 159.966L93.7073 152.876Z",
    fill: "#00B6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0199 142.076L86.1613 148.073L88.6593 149.67L92.5197 143.674L90.0199 142.076Z",
    fill: "#F3B353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1346 135.489L90.3494 138.188L96.8725 135.273L95.6578 132.572L89.1346 135.489Z",
    fill: "#941A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5725 129.63L104.514 131.339L105.226 128.467L98.2845 126.758L97.5725 129.63Z",
    fill: "#146B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.992 122.137L113.935 117.102L111.835 119.193L116.892 124.23L118.992 122.137Z",
    fill: "#DD368C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.174 128.894L125.326 122.014L122.457 122.777L124.305 129.659L127.174 128.894Z",
    fill: "#F29B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.059 131.463L129.705 138.576L132.671 138.724L133.025 131.611L130.059 131.463Z",
    fill: "#C88B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.105 149.613L136.878 143.563L134.356 142.002L130.581 148.052L133.105 149.613Z",
    fill: "#50805A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.598 157.572L129.44 159.892L135.047 155.476L133.206 153.154L127.598 157.572Z",
    fill: "#208ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.954 165.047L121.723 167.904L128.629 166.06L127.86 163.201L120.954 165.047Z",
    fill: "#6BBC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.758 171.587L118.664 173.431L119.434 170.575L112.528 168.729L111.758 171.587Z",
    fill: "#146B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.47 171.412L106.475 175.276L108.088 172.79L102.081 168.926L100.47 171.412Z",
    fill: "#084A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7817 166.348L94.1566 172.627L96.7747 171.231L93.3999 164.951L90.7817 166.348Z",
    fill: "#E5364E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6152 157.617L83.6769 158.049L84.7138 165.097L87.6521 164.664L86.6152 157.617Z",
    fill: "#CD9E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8455 154.428L81.7159 155.186L83.5482 148.301L80.6778 147.543L78.8455 154.428Z",
    fill: "#1FA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5365 139.188L82.4313 137.1L77.3871 142.149L79.4923 144.235L84.5365 139.188Z",
    fill: "#C9224C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8497 130.701L83.2103 133.331L89.5636 130.064L88.203 127.436L81.8497 130.701Z",
    fill: "#00B6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2897 121.375L90.2025 124.332L97.3488 124.543L97.436 121.586L90.2897 121.375Z",
    fill: "#F3B353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.457 119.717L107.109 122.328L108.198 119.576L101.546 116.965L100.457 119.717Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.996 111.05L120.05 116.088L122.15 113.995L117.096 108.959L114.996 111.05Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.847 119.497L128.186 112.887L125.429 113.988L128.092 120.599L130.847 119.497Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 121.219L134.236 121.422L134.723 128.529L137.686 128.326L137.199 121.219Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.002 131.003L139.062 138.062L142.006 138.455L142.946 131.395L140.002 131.003Z",
    fill: "#DD368C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.202 149.628L145.942 143.557L143.411 142.01L139.671 148.08L142.202 149.628Z",
    fill: "#F29B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.252 157.825L139.198 160.061L144.599 155.394L142.653 153.158L137.252 157.825Z",
    fill: "#C88B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.091 166.199L133.229 168.932L139.832 166.206L138.697 163.473L132.091 166.199Z",
    fill: "#50805A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.466 172.385L124.33 172.809L124.505 175.761L131.642 175.337L131.466 172.385Z",
    fill: "#208ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.798 177.785L114.375 180.713L121.449 181.736L121.872 178.809L114.798 177.785Z",
    fill: "#5FB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.651 180.592L109.754 184.305L111.302 181.778L105.199 178.066L103.651 180.592Z",
    fill: "#146B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7205 177.892L97.3752 183.296L99.6297 181.369L94.9732 175.965L92.7205 177.892Z",
    fill: "#084A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1827 171.893L86.6622 178.116L89.2564 176.676L85.7786 170.453L83.1827 171.893Z",
    fill: "#E5364E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5236 162.818L76.5659 163.088L77.2126 170.18L80.1703 169.911L79.5236 162.818Z",
    fill: "#CD9E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2294 160.016L74.1324 160.647L75.6594 153.69L72.7581 153.057L71.2294 160.016Z",
    fill: "#CD9E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9199 143.754L72.3669 142.242L68.7124 148.362L71.2637 149.875L74.9199 143.754Z",
    fill: "#1FA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6302 131.152L70.1622 135.742L72.077 138.003L77.5433 133.415L75.6302 131.152Z",
    fill: "#C9224C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5355 125.099L75.7605 127.793L82.2734 124.854L81.0467 122.158L74.5355 125.099Z",
    fill: "#EA584B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7576 115.273L82.6598 116.131L83.0146 119.067L90.1124 118.21L89.7576 115.273Z",
    fill: "#00B6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6587 112.828L99.664 114.255L100.258 111.357L93.254 109.93L92.6587 112.828Z",
    fill: "#F3B353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.166 111.005L105.017 107.371L103.502 109.914L109.651 113.549L111.166 111.005Z",
    fill: "#941A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.412 103.761L124.72 108.53L126.709 106.334L121.4 101.564L119.412 103.761Z",
    fill: "#F09352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.979 112.134L134.181 106.1L131.664 107.673L135.464 113.705L137.979 112.134Z",
    fill: "#146B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.232 123.163L143.19 116.338L140.344 117.184L142.385 124.009L145.232 123.163Z",
    fill: "#084A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.46 130.128L147.605 129.316L145.642 136.166L148.499 136.977L150.46 130.128Z",
    fill: "#E5364E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.885 152.26L153.466 146.792L151.185 144.896L146.604 150.364L148.885 152.26Z",
    fill: "#CD9E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7 162.258L145.302 164.749L151.323 160.909L149.722 158.418L143.7 162.258Z",
    fill: "#1FA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.585 170.698L140.313 173.566L147.244 171.818L146.515 168.949L139.585 170.698Z",
    fill: "#C9224C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.335 183.416L124.08 186.363L131.203 186.979L131.458 184.032L124.335 183.416Z",
    fill: "#00B6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.766 178.009L133.63 178.439L133.808 181.392L140.944 180.962L140.766 178.009Z",
    fill: "#EA584B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.027 189.811L118.88 191.844L119.728 189.008L112.875 186.977L112.027 189.811Z",
    fill: "#F3B353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9225 188.839L103.423 193.391L105.319 191.115L99.8201 186.564L97.9225 188.839Z",
    fill: "#941A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5953 183.695L90.418 189.714L92.9281 188.132L89.1037 182.113L86.5953 183.695Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8207 175.888L78.3617 182.547L81.1377 181.495L78.5967 174.838L75.8207 175.888Z",
    fill: "#EB7D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7449 164.432L68.3561 171.543L71.3216 171.705L71.7104 164.594L68.7449 164.432Z",
    fill: "#DD368C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8049 158.419L64.5844 159.463L67.1048 152.797L64.3253 151.754L61.8049 158.419Z",
    fill: "#F29B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 144.528L62.3059 146.391L66.8114 140.861L64.5055 138.996L60 144.528Z",
    fill: "#C88B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2559 114.705L68.1805 118.459L69.7453 120.973L75.8206 117.219L74.2559 114.705Z",
    fill: "#208ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0345 126.395L60.9591 130.149L62.5256 132.664L68.5992 128.908L67.0345 126.395Z",
    fill: "#50805A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5547 108.758L76.3765 111.601L83.2463 109.628L82.4244 106.787L75.5547 108.758Z",
    fill: "#5FB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.495 102.051L85.4197 105.008L92.5668 105.19L92.6421 102.233L85.495 102.051Z",
    fill: "#146B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3716 101.023L103.095 103.442L104.104 100.659L97.3804 98.2402L96.3716 101.023Z",
    fill: "#41AF6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.951 102.481L110.394 98L108.526 100.299L114.083 104.782L115.951 102.481Z",
    fill: "#EDE669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9 113.65V131.065H183.846V119.094L178.355 127.827H177.125L171.635 119.094V131.065H168.605V113.65H171.635L177.739 123.265L183.846 113.65H186.9Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.613 127.239H193.62L192.242 131.065H189.091L195.394 113.65H198.841L205.145 131.065H201.995L200.615 127.239H200.613ZM199.579 124.37L197.117 117.576L194.656 124.37H199.581H199.579Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.097 122.358C221.097 127.239 217.651 131.065 212.677 131.065H206.67V113.65H212.677C217.651 113.65 221.097 117.476 221.097 122.358ZM218.069 122.358C218.069 118.58 215.705 116.495 212.677 116.495H209.698V128.22H212.677C215.705 128.22 218.069 126.136 218.069 122.358Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.997 116.495V120.764H231.314V123.608H225.997V128.22H232.768V131.065H222.969V113.65H232.768V116.495H225.997Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.955 113.65H241.926V131.065H244.955V113.65Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.312 113.65V131.065H259.284L250.421 118.727V131.065H247.392V113.65H250.421L259.284 125.988V113.65H262.312Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.622 149.36C180.622 152.598 178.136 154.389 174.416 154.389H168.607V136.975H173.999C177.643 136.975 179.637 138.912 179.637 141.66C179.637 143.084 178.947 144.285 177.889 145.095C179.44 145.979 180.622 147.449 180.622 149.362M171.635 143.844H173.999C175.624 143.844 176.609 143.232 176.609 141.834C176.609 140.509 175.624 139.823 173.999 139.823H171.635V143.844ZM177.594 149.191C177.594 147.72 176.485 146.689 174.492 146.689H171.635V151.546H174.416C176.484 151.546 177.592 150.664 177.592 149.192",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.587 150.561H185.594L184.216 154.387H181.065L187.368 136.973H190.815L197.119 154.387H193.968L192.589 150.561H192.587ZM191.553 147.692L189.091 140.898L186.629 147.692H191.553Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.737 136.975V154.389H210.707L201.844 142.051V154.389H198.815V136.975H201.844L210.707 149.312V136.975H213.737Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.408 144.724C233.408 150.953 229.789 154.632 224.57 154.632C219.351 154.632 215.928 150.56 215.928 145.679C215.928 140.798 219.596 136.727 224.915 136.727C227.919 136.727 230.208 138.149 231.785 140.283L229.494 142.049C228.559 140.724 227.082 139.571 224.915 139.571C221.418 139.571 218.956 142.27 218.956 145.679C218.956 149.088 221.247 151.787 224.57 151.787C227.475 151.787 229.494 150.119 230.134 147.568H223.831V144.724H233.408Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.768 151.544V154.389H235.599V136.975H238.627V151.544H245.768Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.162 150.561H252.169L250.791 154.387H247.64L253.943 136.973H257.39L263.693 154.387H260.543L259.164 150.561H259.162ZM258.128 147.692L255.666 140.898L253.204 147.692H258.128Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.646 145.682C279.646 150.563 276.199 154.389 271.225 154.389H265.219V136.975H271.225C276.199 136.975 279.646 140.801 279.646 145.682ZM276.618 145.682C276.618 141.904 274.254 139.819 271.225 139.819H268.247V151.544H271.225C274.254 151.544 276.618 149.46 276.618 145.682Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.546 139.819V144.088H289.863V146.933H284.546V151.544H291.315V154.389H281.516V136.975H291.315V139.819H284.546Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.378 149.114C295.476 150.93 296.781 151.787 298.258 151.787C299.883 151.787 300.77 150.954 300.77 149.924C300.77 148.526 299.441 147.865 297.447 146.784C293.926 144.774 292.72 143.521 292.72 141.193C292.72 138.544 295.009 136.729 297.89 136.729C301.065 136.729 303.159 139.082 303.232 142.051H300.204C300.13 140.507 299.219 139.575 297.89 139.575C296.731 139.575 295.748 140.261 295.748 141.315C295.748 142.639 296.757 143.156 298.53 144.087C301.853 145.878 303.798 147.375 303.798 150.024C303.798 152.966 301.312 154.634 298.258 154.634C294.59 154.634 292.423 151.985 292.349 149.114H295.378Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 136.975V154.389H316.946V147.152H308.748V154.389H305.72V136.975H308.748V144.308H316.946V136.975H320Z",
    fill: "#0E1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.655 160.297L189.19 177.71H185.546L181.631 165.25L177.715 177.71H174.073L168.607 160.297H171.709L175.893 173.738L180.08 160.297H183.182L187.366 173.738L191.553 160.297H194.655Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.383 163.142V167.41H204.7V170.255H199.383V174.867H206.153V177.711H196.353V160.297H206.153V163.142H199.383Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.446 163.142V167.41H216.763V170.255H211.446V174.867H218.217V177.711H208.418V160.297H218.217V163.142H211.446Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.475 168.218L234.442 177.711H230.848L225.505 170.475L223.683 172.535V177.711H220.655V160.297H223.683V168.073L230.529 160.297H234.442L227.475 168.218Z",
    fill: "#2587BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.843 189.031V199.147H178.63C178.011 198.153 176.83 197.184 175.087 196.24C173.344 195.297 171.867 194.806 170.654 194.768L170.237 193.202C171 192.624 172.328 191.956 174.224 191.201C174.795 190.987 176.238 190.441 178.553 189.559V189.031H169.327V187.898H181.224V189.031H179.841H179.843ZM178.554 191.05C177.237 191.491 175.19 192.364 172.417 193.674C174.811 194.53 176.858 195.7 178.554 197.184V191.05Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.708 189.031V199.13H182.382V189.031H180.733V187.898H185.223V189.031H183.708Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.615 193.788C187.782 193.788 187.116 193.52 186.617 192.985C186.117 192.449 185.869 191.761 185.869 190.919C185.869 190.152 186.124 189.507 186.637 188.984C187.148 188.462 187.788 188.201 188.56 188.201C189.333 188.201 189.957 188.51 190.436 189.126C190.877 189.692 191.098 190.373 191.098 191.164C191.098 191.955 190.884 192.607 190.455 193.079C190.026 193.551 189.413 193.786 188.617 193.786M186.002 196.541L186.021 194.597C189.077 196.824 191.124 198.648 192.16 200.071V201.335C191.453 200.705 190.474 199.844 189.223 198.749C188.137 197.806 187.063 197.07 186.002 196.541ZM188.579 189.502C188.125 189.502 187.749 189.637 187.452 189.907C187.155 190.178 187.008 190.533 187.008 190.974C187.008 191.389 187.162 191.763 187.471 192.096C187.78 192.43 188.144 192.595 188.56 192.595C188.952 192.595 189.286 192.458 189.564 192.18C189.842 191.904 189.981 191.571 189.981 191.18C189.981 190.764 189.849 190.382 189.583 190.028C189.317 189.677 188.984 189.5 188.579 189.5",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.016 189.031V199.128H202.786C202.786 198.889 202.801 198.543 202.832 198.086C202.863 197.63 202.88 197.283 202.88 197.045C202.88 194.67 202.273 193.483 201.061 193.483C200.631 193.483 200.253 193.699 199.924 194.131C199.632 194.514 199.469 194.933 199.431 195.389H197.916C197.891 194.898 197.726 194.445 197.424 194.03C197.084 193.565 196.679 193.332 196.211 193.332C195.643 193.332 195.2 193.558 194.885 194.011C194.607 194.413 194.468 194.91 194.468 195.502C194.468 196.748 195.219 197.371 196.722 197.371C196.873 197.371 197.031 197.364 197.196 197.352L196.76 198.673C196.532 198.699 196.362 198.711 196.249 198.711C195.288 198.711 194.502 198.39 193.89 197.748C193.277 197.106 192.972 196.302 192.972 195.332C192.972 194.363 193.265 193.533 193.852 192.917C194.44 192.301 195.231 191.992 196.23 191.992C197.228 191.992 198.036 192.565 198.731 193.709C199.502 192.565 200.291 191.992 201.101 191.992C201.77 191.992 202.331 192.527 202.787 193.596V189.029H191.894V187.896H205.327V189.029H204.019L204.016 189.031Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 189.031V199.13H206.536V189.031H204.887V187.898H209.377V189.031H207.862Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.418 199.864C212.915 199.864 211.93 199.619 211.462 199.128C210.364 197.97 209.815 196.549 209.815 194.863C209.815 193.857 210.131 192.831 210.762 191.786C211.167 191.119 211.886 190.201 212.922 189.031H208.964V187.898H215.329V189.031C214.269 189.446 213.31 190.196 212.45 191.277C211.553 192.421 211.105 193.541 211.105 194.636C211.105 197.354 212.236 198.713 214.497 198.713C214.813 198.713 215.154 198.575 215.52 198.297V199.619C215.19 199.782 214.825 199.864 214.422 199.864",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.877 189.031V193.541C217.848 192.258 219.601 191.321 221.144 190.729L222.432 192.409C221.777 194.02 221.447 195.278 221.447 196.184C221.447 197.002 221.643 197.958 222.036 199.052L221.07 199.505C220.578 198.222 220.331 197.297 220.331 196.731C220.331 195.358 220.469 193.964 220.747 192.541C219.334 193.107 217.633 194.216 215.652 195.863L214.554 194.825V189.031H213.531V187.898H223.364V189.031H215.88H215.877Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.285 199.864C226.782 199.864 225.797 199.619 225.33 199.128C224.23 197.97 223.681 196.549 223.681 194.863C223.681 193.857 223.997 192.831 224.628 191.786C225.033 191.119 225.752 190.201 226.788 189.031H222.83V187.898H229.196V189.031C228.135 189.446 227.176 190.196 226.317 191.277C225.419 192.421 224.972 193.541 224.972 194.636C224.972 197.354 226.102 198.713 228.364 198.713C228.679 198.713 229.021 198.575 229.386 198.297V199.619C229.057 199.782 228.691 199.864 228.288 199.864",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.512 189.031V199.147H236.223V191.606C236.223 191.052 236.052 190.532 235.71 190.054C235.329 189.535 234.871 189.276 234.338 189.276C233.893 189.276 233.516 189.429 233.203 189.734C232.893 190.04 232.737 190.416 232.737 190.862C232.737 192.058 233.161 192.655 234.006 192.655C234.284 192.655 234.593 192.529 234.935 192.277L235.086 192.164V193.617C234.706 194.008 234.24 194.202 233.684 194.202C233.203 194.202 232.761 193.926 232.358 193.372C232.282 193.259 232.131 193.039 231.903 192.711C231.436 193.742 230.753 194.259 229.856 194.259C229.25 194.259 228.796 194.008 228.494 193.504V192.145C228.847 192.548 229.225 192.749 229.63 192.749C230.527 192.749 230.975 192.088 230.975 190.769C230.975 189.625 230.115 189.045 228.398 189.033H227.392V187.9H229.685C230.518 187.9 231.256 188.504 231.901 189.712C232.066 189.211 232.334 188.784 232.706 188.431C233.078 188.077 233.504 187.9 233.984 187.9C234.715 187.9 235.43 188.386 236.124 189.354V187.9H238.776V189.033H237.506L237.512 189.031Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.854 189.92C246.264 191.493 245.467 193.06 245.467 194.619C245.467 195.362 245.625 196.072 245.943 196.752C246.334 197.608 246.876 198.035 247.573 198.035C247.9 198.035 248.228 197.941 248.557 197.752L248.973 198.89C248.557 199.113 248.132 199.226 247.703 199.226C246.452 199.226 245.543 198.636 244.975 197.453C244.546 196.573 244.332 195.443 244.332 194.06C244.332 192.953 244.692 191.891 245.411 190.874C245.79 190.359 246.473 189.436 247.458 188.103C247.849 187.574 248.044 187.128 248.044 186.763C248.044 186.135 247.616 185.545 246.758 184.992L245.066 183.925C244.438 183.434 244.124 182.897 244.124 182.317C244.124 181.461 244.447 180.71 245.09 180.066L246.113 180.765C245.759 181.168 245.582 181.551 245.582 181.916C245.582 182.468 246.018 183.011 246.89 183.539C247.962 184.181 248.544 184.539 248.633 184.615C249.251 185.105 249.561 185.665 249.561 186.294C249.561 186.684 249.422 187.2 249.144 187.842L250.186 187.88V189.031C249.1 189.156 248.322 189.453 247.856 189.918",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.105 187.898H261.437V188.974H249.105V187.898ZM255.83 199.147C254.478 199.147 253.312 198.682 252.325 197.75C251.694 197.146 250.942 196.082 250.071 194.561L250.827 193.579C252.356 196.448 253.864 197.882 255.355 197.882C256.34 197.882 257.17 197.553 257.846 196.892C258.522 196.232 258.86 195.41 258.86 194.428C258.86 193.548 258.526 192.752 257.857 192.042C257.187 191.33 256.41 190.975 255.527 190.975C254.592 190.975 254.125 191.321 254.125 192.013C254.125 192.327 254.252 192.594 254.504 192.816C254.756 193.035 255.041 193.152 255.357 193.164L254.713 194.202C254.12 194.19 253.621 193.957 253.216 193.504C252.811 193.051 252.608 192.529 252.608 191.939C252.608 191.21 252.917 190.635 253.536 190.222C254.067 189.856 254.719 189.674 255.489 189.674C256.714 189.674 257.803 190.139 258.757 191.071C259.711 192.002 260.187 193.071 260.187 194.279C260.187 195.714 259.828 196.865 259.107 197.733C258.337 198.677 257.244 199.148 255.83 199.148",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.27 189.033V199.149H270.057C269.414 198.13 268.261 197.167 266.6 196.261C264.939 195.355 263.489 194.883 262.252 194.846L261.835 193.298C263.793 192.04 266.483 190.795 269.906 189.561V189.033H260.926V187.9H272.444V189.033H271.268H271.27ZM269.982 191.052C267.866 191.781 265.883 192.687 264.033 193.77C266.2 194.487 268.184 195.625 269.982 197.186V191.052ZM266.533 199.507C266.116 199.08 265.478 198.653 264.62 198.224L265.188 197.167C265.97 197.495 266.677 198.004 267.309 198.696L266.531 199.507H266.533Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.002 189.031V199.09H273.657V189.031H272.046V187.898H273.657V187.483C273.744 186.502 273.228 185.628 272.106 184.86C271.085 184.155 270.064 183.803 269.041 183.803C268.096 183.803 267.056 184.067 265.921 184.596C265.329 184.872 264.395 185.4 263.122 186.181L262.422 185.237C264.924 183.388 267.077 182.463 268.884 182.463C270.273 182.463 271.612 182.928 272.9 183.859C274.302 184.879 275.004 186.068 275.004 187.426V187.898H276.311V189.031H275.004H275.002Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 103.338,
    fill: "white",
    transform: "translate(60 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMibw);
export default __webpack_public_path__ + "static/media/mibw.31af8f52ab0426e6cc4899ce2fdb0b8b.svg";
export { ForwardRef as ReactComponent };